module.exports = __webpack_public_path__ + "static/media/Times Higher Education.aafd606a.png";